import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "../Tooltip";

const Basic = ({ data: { text, icon, color, value, unit, acronymKey } }) => {
  return (
    <div
      className="flex flex-col flex-wrap lg:flex-nowrap items-center md:flex-row gap-4  text-center md:text-start text-base sm:text-lg min-w-20"
      style={{ color: color }}
    >
      {icon && <FontAwesomeIcon icon={icon} size="sm" className="text-lg" />}

      <div>
        <p className="text-wrap  xl:text-nowrap ">
          {acronymKey ? <Tooltip id={acronymKey}>{text}</Tooltip> : text}
        </p>
        <p>
          <i>
            <b className="text-start">{value}</b>
          </i>
          {/*   <span className="ml-1">{unit}</span> */}
        </p>
      </div>
    </div>
  );
};

export default Basic;
